var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 10a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-8.5a3 3 0 0 1 3 3c0 1.082-.376 1.645-1.337 2.462C6.699 7.78 6.5 8.148 6.5 9h-1c0-1.237.394-1.847 1.516-2.8.758-.645.984-.983.984-1.7a2 2 0 0 0-4 0V5H3v-.5a3 3 0 0 1 3-3"
})));
export { SvgQuestionIcon as ReactComponent };
export default __webpack_public_path__ + "e73894fe6cf33630571355e7f984f4c5.svg";